import React from 'react';

import logo from './logo.svg';
import whiteLogo from './logo-white.svg';

const ASPECT_RATIO = 57/52;

function Logo({size = 52, white, src, ...props}) {
  const defaultSrc = white ? whiteLogo : logo;
  return <img {...props} src={src ? src : defaultSrc} width={size * ASPECT_RATIO} height={size} alt="" />;
}

export default Logo;